import _ from 'underscore';

export default function PreviewGroupShowController(
  CurrentPartnerService,
  CreativeGroupService,
  CreativeService,
  CreativeListService,
  PreviewGroupService,
  RenderService,
  $state,
  MixpanelService,
  FlashService,
  SettingsService,
  partner
) {
  const vm = this;
  let partnerAllowsDownload = false;
  let allDisplayCreatives = false;

  vm.creativeFound = true;
  vm.state = $state;
  vm.selectCreative = selectCreative;
  vm.creativeService = CreativeService;
  vm.creativeGroupService = CreativeGroupService;
  vm.showDownloadButton = showDownloadButton;
  vm.addMoreCreativesButton = addMoreCreativesButton;
  vm.deleteAdGroup = deleteAdGroup;
  vm.creatives = [];
  vm.showEmbedLink = false;
  vm.partner = partner;
  SettingsService.showBuilderHeader = false;

  const isDsp = (partner) => !!partner && partner.partnerType === 'DSP';

  vm.canExportCreatives = () => {
    const { creatives, partner } = vm;

    if (!creatives || creatives.length === 0 || !isDsp(partner)) {
      return false;
    }

    const { action } = creatives[0];

    return action !== 'banner' && action !== 'instream-video';
  };

  vm.canExportVast = () => {
    const { creatives, partner } = vm;
    if (!creatives || creatives.length === 0 || !isDsp(partner)) {
      return false;
    }
    const { action, status } = creatives[0];

    return action === 'instream-video' && status === 'complete';
  };

  CurrentPartnerService.get().then(partner => {
    partnerAllowsDownload = partner.allowCreativeExport;
  });

  PreviewGroupService.show($state.params.id).then(response => {
    vm.name = response.data.name;
    CreativeGroupService.setCreativeGroup(response.data);
    vm.creatives = CreativeGroupService.group.creativePreviews;

    // we can (currrently) only export if all creatives are clickouts
    allDisplayCreatives = _.every(
      vm.creatives,
      creative => creative.action === 'clickout'
    );
  });

  PreviewGroupService.initUserGroups().then(() => {
    vm.userOwnsGroup = !!_.find(
      PreviewGroupService.userGroups,
      ({ id }) => `${id}` === $state.params.id
    );
  });

  MixpanelService.track('Demo Group Viewed', {
    demoGroupId: $state.params.id
  });

  function showDownloadButton() {
    return partnerAllowsDownload && allDisplayCreatives;
  }

  function addMoreCreativesButton() {
    $state.go('creativePreview.editPreviewGroup', {
      id: $state.params.id
    });
  }

  function selectCreative(creative) {
    CreativeService.setCreative(creative);
    RenderService.setSite();
  }

  function deleteAdGroup() {
    if (!confirm("Are you sure you want to delete this ad group?")) {
      return;
    }

    return PreviewGroupService.destroy($state.params.id).then(
      () => {
        FlashService.push('success', 'Your ad group has been deleted.');
        CreativeListService.refreshList().then(() => {
          $state.go('creativePreview.home');
        });
      },
      () => {
        FlashService.push('error', 'Something went wrong, please try again.');
      }
    );
  }

  return vm;
}

PreviewGroupShowController.$inject = [
  'CurrentPartnerService',
  'CreativeGroupService',
  'CreativeService',
  'CreativeListService',
  'PreviewGroupService',
  'RenderService',
  '$state',
  'MixpanelService',
  'FlashService',
  'SettingsService',
  'partner'
];
